const ROOTS = {
  DASHBOARD: '/dashboard',
  ADMIN: '/admin',
  SUPERADMIN: '/superadmin',
  EXAMINATION: '/examination',
  MANDATORY_UNIT: '/mandatory-unit',
  QR_CODE: '/qr-code',
  INVITATIONS: '/invitations',
};

export const paths = {
  auth: {
    signIn: `/login`,
    signUp: `/register`,
  },
  dashboard: {
    root: ROOTS.DASHBOARD,
  },
  invitations: {
    root: ROOTS.INVITATIONS,
  },
  admin: {
    root: ROOTS.ADMIN,
    userManagement: `${ROOTS.ADMIN}/user-management`,
    groupManagement: `${ROOTS.ADMIN}/group-management`,
    user: {
      root: (id: number) => `${ROOTS.ADMIN}/user-management/${id}`,
      general: (id: number) => `${ROOTS.ADMIN}/user-management/${id}/general`,
      roles: (id: number) => `${ROOTS.ADMIN}/user-management/${id}/roles`,
      groups: (id: number) => `${ROOTS.ADMIN}/user-management/${id}/groups`,
      license: (id: number) => `${ROOTS.ADMIN}/user-management/${id}/license`,
    },
  },
  superadmin: {
    root: ROOTS.SUPERADMIN,
    swaggerApiDocumentation: `${ROOTS.SUPERADMIN}/swagger-api-documentation`,
    userManagement: `${ROOTS.SUPERADMIN}/user-management`,
    groupManagement: `${ROOTS.SUPERADMIN}/group-management`,
    userCleanup: `${ROOTS.SUPERADMIN}/user-cleanup`,
  },
  examination: {
    root: ROOTS.EXAMINATION,
    details: (id: string | number) => `${ROOTS.EXAMINATION}/${id}`,
    control: (id: string | number) => `${ROOTS.EXAMINATION}/${id}/control`,
    statistics: (id: string | number) => `${ROOTS.EXAMINATION}/${id}/statistics`,
    userStatistics: (id: string | number) => `${ROOTS.EXAMINATION}/${id}/user-statistics`,
  },
  mandatoryUnit: {
    root: ROOTS.MANDATORY_UNIT,
    userCertificateOverview: (id: string | number) =>
      `${ROOTS.MANDATORY_UNIT}/${id}/user-certificate-overview`,
  },
  qrCode: {
    info: `${ROOTS.QR_CODE}/info`,
    lesson: (lessonId: string | number) => `${ROOTS.QR_CODE}/lesson/${lessonId}`,
    redirect: (code: string) => `${ROOTS.QR_CODE}/r/${code}`,
  },
};
